import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#214d8e",
      light: "rgb(56, 125, 255)",
      dark: "rgb(0, 60, 255)",
    },
    error: {
      main: "#d32f2f",
      light: "#ffd9d9",
      secondary: "#ffebee",
      dark: "#b71c1c",
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input::-ms-reveal": {
            display: "none",
          },
          "& input::-ms-clear": {
            display: "none",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: '"Inter", "Montserrat", "Roboto", "Helvetica", "Arial"',
    h6: {
      fontWeight: 700,
    },
    body1: {
      fontSize: "0.9375rem",
    },
  },

  shape: {
    borderRadius: 12,
  },
});

export default theme;
